export const DEVICE_SHELL_ATTRIBUTE = "data-device-shell";
export const DEVICE_SHELL_VALUES = [
  "desktop",
  "tablet",
  "mobile",
  "tv",
  "4k",
  "watch",
  "ereader",
  "car",
  "xr",
  "foldable",
  "smart-display",
  "console",
] as const;

export type DeviceShell = (typeof DEVICE_SHELL_VALUES)[number];

export function isDeviceShell(value: string | null | undefined): value is DeviceShell {
  return DEVICE_SHELL_VALUES.includes(value as DeviceShell);
}
